jQuery.fn.datePicker = function () {
	let inputText = jQuery(this);
	let data = {};

	const monthNames = [
		"Enero",
		"Febrero",
		"Marzo",
		"Abril",
		"Mayo",
		"Junio",
		"Julio",
		"Agosto",
		"Septiembre",
		"Octubre",
		"Noviembre",
		"Diciembre",
	];

	initDatePicker();
	renderCalendar();

	inputText.on("click", openCalendar);
	inputText.on("input", renderCalendar);

	/**
	 * Prev Month Event
	 */
	data.calendarButtonLeft.on("click", function () {
		data.monthState--;
		if (data.monthState < 0) {
			data.monthState = 11;
			data.yearState--;
		}

		generateCalendar(data.monthState, data.yearState);
	});

	/**
	 * Next Month Event
	 */
	data.calendarButtonRight.on("click", function () {
		data.monthState++;
		if (data.monthState > 11) {
			data.monthState = 0;
			data.yearState++;
		}

		generateCalendar(data.monthState, data.yearState);
	});

	/**
	 * Year Event
	 */
	data.calendarHeaderYear.on("click", openCalendarYears);

	/**
	 * Month Event
	 */
	data.calendarHeaderMonth.on("click", openCalendarMonths);

	/**
	 * Input Writing Enter Event
	 */
	inputText.keyup(function (e) {
		if (e.keyCode == 13) {
			closeCalendar();
		}
	});

	/**
	 * Set Value to Input
	 * @param {int} d
	 * @param {int} y
	 * @param {int} m
	 */
	const setValue = function (d, m, y) {
		let value = `${beforeZero(d)}/${beforeZero(m + 1)}/${y}`;

		inputText.val(value);
		data.day = d;
		data.month = m;
		data.year = y;

		renderCalendar();
	};

	/**
	 * Create Tags HTML
	 */
	function initDatePicker() {
		// Create Parent <div>
		inputText.after(`<div class="datepicker"></div>`);
		let content = inputText.siblings(".datepicker");

		// Change Position Input
		inputText.appendTo(content);

		// Generate Layout
		let html = `
			<div class="datepicker__content">
				<div class="datepicker__dialog">
					<div class="datepicker__header">
						<button type="button" class="datepicker__arrow left">L</button>
						<div class="datepicker__title"><span class="datepicker__month"></span> <span class="datepicker__year"></span></div>
						<button type="button" class="datepicker__arrow right">R</button>
					</div>
					<div class="datepicker__body">
						<div class="datepicker__days">
							<span>L</span>
							<span>M</span>
							<span>M</span>
							<span>J</span>
							<span>V</span>
							<span>S</span>
							<span>D</span>
						</div>
						<div class="datepicker__numeric"></div>
					</div>
					<div class="datepicker__scroll is--months">
						<div class="datepicker__boxes"></div>
					</div>
					<div class="datepicker__scroll is--years">
						<div class="datepicker__boxes"></div>
					</div>
				</div>
			</div>
		`;

		inputText.after(html);

		// Set Variables
		data.calendar = content;
		data.calendarButtonLeft = content.find(".datepicker__arrow.left");
		data.calendarButtonRight = content.find(".datepicker__arrow.right");
		data.calendarDays = content.find(".datepicker__numeric");
		data.calendarHeaderYear = content.find(".datepicker__year");
		data.calendarHeaderMonth = content.find(".datepicker__month");
		data.calendarBodyMonths = content.find(
			".datepicker__scroll.is--months .datepicker__boxes"
		);
		data.calendarBodyYears = content.find(
			".datepicker__scroll.is--years .datepicker__boxes"
		);
	}

	/**
	 * Render Calendar Data
	 */
	function renderCalendar() {
		let inputValue = inputText.val();

		// Reorder Date Format
		try {
			let inputValueSplit = inputValue.split("/");
			inputValue = `${inputValueSplit[1]}/${inputValueSplit[0]}/${inputValueSplit[2]}`;
		} catch (error) {}
		// Create Date
		let nowDate = new Date();
		let inputDate = new Date(inputValue);

		// Set Date
		if (inputDate == "Invalid Date") {
			data.year = nowDate.getFullYear();
			data.yearState = nowDate.getFullYear();

			data.month = nowDate.getMonth();
			data.monthState = nowDate.getMonth();

			data.day = nowDate.getDate();
			data.dayState = nowDate.getDate();

			data.activeDay = false;
		} else {
			data.year = inputDate.getFullYear();
			data.yearState = inputDate.getFullYear();

			data.month = inputDate.getMonth();
			data.monthState = inputDate.getMonth();

			data.day = inputDate.getDate();
			data.dayState = inputDate.getDate();

			data.activeDay = true;
		}

		generateCalendar(data.monthState, data.yearState);
		generateCalendarMonths();
		generateCalendarYears();
	}

	/**
	 * Generate Calendar Values
	 * @param {int} month
	 * @param {int} year
	 */
	function generateCalendar(month, year) {
		let daysOfMonth = [
			31,
			getFebDays(year),
			31,
			30,
			31,
			30,
			31,
			31,
			30,
			31,
			30,
			31,
		];

		let html = ``;

		// Reset Content Values
		data.calendarDays.html(html);

		// Set Date
		let currDate = new Date();
		if (month == undefined) month = currDate.getMonth();
		if (year == undefined) year = currDate.getFullYear();

		// Print Month and Year
		let currMonth = `${monthNames[month]}`;
		data.calendarHeaderMonth.text(currMonth);
		data.calendarHeaderYear.text(year);

		// Get First Day of Month
		let firstDay = new Date(year, month, 1);

		// Print Days
		for (let i = 1; i <= daysOfMonth[month] + firstDay.getDay() - 1; i++) {
			if (i >= firstDay.getDay()) {
				html = `<span data-value="${beforeZero(
					i - firstDay.getDay() + 1
				)}"><i>${i - firstDay.getDay() + 1}</i></span>`;

				if (
					i - firstDay.getDay() + 1 === currDate.getDate() &&
					year === currDate.getFullYear() &&
					month === currDate.getMonth()
				) {
					html = `<span class="is--today" data-value="${beforeZero(
						i - firstDay.getDay() + 1
					)}"><i>${i - firstDay.getDay() + 1}</i></span>`;
				}

				if (
					i - firstDay.getDay() + 1 === data.day &&
					year === data.year &&
					month === data.month &&
					data.activeDay === true
				) {
					html = `<span class="is--active" data-value="${beforeZero(
						i - firstDay.getDay() + 1
					)}"><i>${i - firstDay.getDay() + 1}</i></span>`;
				}
			} else {
				html = `<span class="is--null"><i></i></span>`;
			}

			data.calendarDays.append(html);
		}

		// Set Event to Simple Days
		data.calendarSimpleDay = data.calendarDays
			.children()
			.filter("[data-value]");

		jQuery.each(data.calendarSimpleDay, function () {
			let day = jQuery(this);
			day.on("click", function () {
				data.dayState = parseInt(day.attr("data-value"));

				data.calendarSimpleDay.removeClass("is--active");
				day.addClass("is--active");

				setValue(data.dayState, data.monthState, data.yearState);

				closeCalendar();
			});
		});
	}

	/**
	 * Generate Calendar Year Values
	 */
	function generateCalendarYears() {
		let htmlYears = ``;
		data.calendarBodyYears.html(htmlYears);

		let currDate = new Date();
		let minYears = currDate.getFullYear() - 120;
		let maxYears = currDate.getFullYear() + 120;

		for (let i = minYears; i <= maxYears; i++) {
			htmlYears = `<span>${i}</span>`;

			if (i === currDate.getFullYear()) {
				htmlYears = `<span class="is--today">${i}</span>`;
			}

			if (i === data.year && data.activeDay === true) {
				htmlYears = `<span class="is--active">${i}</span>`;
			}

			data.calendarBodyYears.append(htmlYears);
		}

		// Set Event to Simple Years
		jQuery.each(data.calendarBodyYears.children(), function () {
			let year = jQuery(this);
			let currYear = parseInt(year.text());

			year.on("click", function () {
				data.yearState = currYear;

				data.calendarBodyYears.children().removeClass("is--active");
				year.addClass("is--active");

				setValue(data.dayState, data.monthState, data.yearState);

				closeCalendarYears();
			});
		});
	}

	/**
	 * Generate Calendar Month Values
	 */
	function generateCalendarMonths() {
		let htmlMonths = ``;
		data.calendarBodyMonths.html(htmlMonths);

		let currDate = new Date();

		for (i = 0; i < monthNames.length; i++) {
			htmlMonths = `<span data-value="${i}">${monthNames[i]}</span>`;

			if (
				data.yearState == currDate.getFullYear() &&
				i === currDate.getMonth()
			) {
				htmlMonths = `<span class="is--today" data-value="${i}">${monthNames[i]}</span>`;
			}

			if (i === data.month && data.activeDay === true) {
				htmlMonths = `<span class="is--active" data-value="${i}">${monthNames[i]}</span>`;
			}

			data.calendarBodyMonths.append(htmlMonths);
		}

		// Set Event to Simple Months
		jQuery.each(data.calendarBodyMonths.children(), function () {
			let month = jQuery(this);
			let currMonth = parseInt(month.attr("data-value"));

			month.on("click", function () {
				data.monthState = currMonth;

				data.calendarBodyMonths.children().removeClass("is--active");
				month.addClass("is--active");

				setValue(data.dayState, data.monthState, data.yearState);

				closeCalendarMonths();
			});
		});
	}

	/**
	 * Open Calendar
	 */
	function openCalendar() {
		inputText.addClass("is--focus");
		data.calendar.find(".datepicker__content").addClass("is--open");

		let container = data.calendar.find(".datepicker__content")[0];

		container.scrollIntoView({
			behavior: "smooth",
		});
	}

	/**
	 * Close Calendar
	 */
	function closeCalendar() {
		inputText.removeClass("is--focus");
		data.calendar.find(".datepicker__content").removeClass("is--open");
	}

	/**
	 * Open Calendar Years
	 */
	function openCalendarYears() {
		data.calendarBodyYears
			.closest(".datepicker__scroll.is--years")
			.addClass("is--open");

		let container =
			data.calendarBodyYears.children().filter(".is--active").length > 0
				? data.calendarBodyYears.children().filter(".is--active")[0]
				: data.calendarBodyYears.children().filter(".is--today")[0];

		container.scrollIntoView({
			behavior: "smooth",
		});

		openCalendarMonths();
	}

	/**
	 * Close Calendar Years
	 */
	function closeCalendarYears() {
		data.calendarBodyYears
			.closest(".datepicker__scroll.is--years")
			.removeClass("is--open");
	}

	/**
	 * Open Calendar Months
	 */
	function openCalendarMonths() {
		data.calendarBodyMonths
			.closest(".datepicker__scroll.is--months")
			.addClass("is--open");
	}

	/**
	 * Close Calendar Months
	 */
	function closeCalendarMonths() {
		data.calendarBodyMonths
			.closest(".datepicker__scroll.is--months")
			.removeClass("is--open");
	}

	/**
	 * Get Frebruary Days
	 * @param {int} year
	 * @returns
	 */
	function getFebDays(year) {
		return isLeapYear(year) ? 29 : 28;
	}

	/**
	 * Determine Leap Year
	 * @param {int} year
	 * @returns
	 */
	function isLeapYear(year) {
		return (
			(year % 4 === 0 && year % 100 !== 0 && year % 400 !== 0) ||
			(year % 100 === 0 && year % 400 === 0)
		);
	}

	/**
	 * Print 0${int}
	 * @param {int} value
	 * @returns
	 */
	function beforeZero(value) {
		if (value < 10) {
			return `0${value}`;
		} else {
			return value;
		}
	}
};
